import styled from "styled-components";

/** Main title of a panel screen (e.g. "Meus Keepos"). Renders an h1. */
export const PageTitle = styled.h1`
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  color: var(--color-neutral-white);
`;
